import bg from "../assets/background.png";
export const Noise = () => {
  return (
    <>
      <div className="fixed inset-0 -top-[env(safe-area-inset-top)] -bottom-[env(safe-area-inset-bottom)] -z-10 h-[120vh]">
        <div
          style={{ backgroundSize: "128px", backgroundImage: `url(${bg})` }}
          className={`h-full min-h-full bg-repeat opacity-[0.08]`}
        ></div>
      </div>
    </>
  );
};
